var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const fetchCart = (set, get) => __awaiter(void 0, void 0, void 0, function* () {
    set({ isLoading: true, error: null, hasFetchedCart: true });
    try {
        const headers = {};
        if (window.perlaData.restNonce) {
            headers['X-WP-Nonce'] = window.perlaData.restNonce;
        }
        const response = yield fetch(`/wp-json/custom/v1/cart-with-details?currency=${perlaData.currency}&language=${perlaData.language}`, {
            method: 'GET',
            credentials: 'include',
            headers,
        });
        if (!response.ok)
            throw new Error('Failed to fetch cart data.');
        const data = yield response.json();
        if (data.message && data.message === 'Cart is empty.') {
            set({
                cartHeading: data.cart_heading || '',
                checkoutButtonText: data.checkout_button_text || '',
                lateDeliveryLocalization: data.late_delivery_localization || '',
                cartItems: [],
                crossSells: [],
                promoSliderData: data.promo_slider_data || [],
                freeShippingInfo: data.free_shipping_info || null,
                freeShippingLocalization: data.free_shipping_localization || {},
                promocodeLocalization: data.promocode_localization || {},
                cartTotalsLocalization: data.cart_totals_localization || {},
                hideFreeDeliveryOffer: true,
                summary: null,
                isLoading: false,
                error: null,
                cartEmptyMessage: data.cart_empty_message || '',
                goToShopLink: data.go_to_shop_link || '',
                goToShopButtonText: data.go_to_shop_button_text || '',
                cart_item_count: 0,
                promocode: '',
                promocodeStatus: '',
                promocodeStatusMessage: '',
                currency: data.currency || '',
                language: data.language || 'en',
            });
        }
        else {
            set({
                cartHeading: data.cart_heading || '',
                checkoutButtonText: data.checkout_button_text || '',
                checkoutButtonURL: data.checkout_button_url || '',
                lateDeliveryLocalization: data.late_delivery_localization || '',
                cartItems: data.cart_items || [],
                crossSells: data.cross_sells || [],
                promoSliderData: data.promo_slider_data || [],
                hideFreeDeliveryOffer: data.hide_free_delivery_offer || false,
                promocodeLocalization: data.promocode_localization || {},
                summary: data.summary || null,
                freeShippingInfo: data.free_shipping_info || null,
                freeShippingLocalization: data.free_shipping_localization || {},
                cartTotalsLocalization: data.cart_totals_localization || {},
                crossSellLocalization: data.cross_sells_localization || {},
                cart_item_count: data.cart_item_count || 0,
                isLoading: false,
                error: null,
                currency: data.currency || '',
                language: data.language || 'en',
            });
        }
    }
    catch (err) {
        set({
            isLoading: false,
            error: err.message || 'Something went wrong fetching the cart.',
        });
    }
});
